// src/config/stripe-plans.js
// Stripe Billing plan configuration for practitioner subscriptions.
//
// TODO:STRIPE_BILLING — Before launch:
//   1. Go to Stripe Dashboard → Products
//   2. Create 3 Products: Professional, Premier (Essentials is free — no Stripe product needed)
//   3. Each Product gets a monthly recurring Price
//   4. Replace the placeholder price_XXXXXXXXXXXXXXXXXX IDs below with the real ones
//   5. Set REACT_APP_STRIPE_PUBLISHABLE_KEY in .env for the Stripe.js checkout redirect

export const TIER_DISPLAY = {
  free: 'Essentials',
  pro: 'Professional',
  elite: 'Premier',
};

export const STRIPE_PLANS = {
  free: {
    tier: 'free',
    name: 'Essentials',
    price: 0,
    // No Stripe product — free tier
    monthlyPriceId: null,
    features: [
      'Basic directory listing',
      'Up to 3 bookings/month',
      'Standard support',
    ],
  },
  pro: {
    tier: 'pro',
    name: 'Professional',
    price: 49,
    // TODO:STRIPE_BILLING: Replace with real Price ID from Stripe Dashboard
    monthlyPriceId: 'price_XXXXXXXXXXXXXXXXXX',
    features: [
      'DF website builder',
      'Unlimited bookings & payments',
      'Client management CRM',
      'Google Calendar sync',
      'Verification badge',
      'Enhanced directory listing',
      'Email & SMS reminders',
      'Analytics',
    ],
  },
  elite: {
    tier: 'elite',
    name: 'Premier',
    price: 99,
    // TODO:STRIPE_BILLING: Replace with real Price ID from Stripe Dashboard
    monthlyPriceId: 'price_XXXXXXXXXXXXXXXXXX',
    features: [
      'Everything in Professional',
      'AI Session Prep Assistant',
      'Practice Coach insights',
      'Priority directory placement',
      'Newsletter & marketing suite',
    ],
  },
};

// Features lost when downgrading between tiers (used in downgrade warning UI)
export const DOWNGRADE_LOSSES = {
  'elite->pro': [
    'AI Session Prep Assistant',
    'Practice Coach insights',
    'Priority directory placement',
  ],
  'elite->free': [
    'AI Session Prep Assistant',
    'Practice Coach insights',
    'Priority directory placement',
    'DF website builder',
    'Unlimited bookings & payments',
    'Client management CRM',
    'Google Calendar sync',
    'Verification badge',
    'Email & SMS reminders',
  ],
  'pro->free': [
    'DF website builder',
    'Unlimited bookings (capped at 3/month)',
    'Google Calendar sync',
    'Verification badge',
    'Email & SMS reminders',
    'Analytics',
  ],
};

// Features kept when downgrading (reassures practitioners)
export const DOWNGRADE_KEPT = {
  'elite->pro': [
    'DF website builder',
    'Unlimited bookings & payments',
    'Client management CRM',
    'Verification badge',
    'Email & SMS reminders',
    'Analytics',
  ],
  'elite->free': [
    'Basic directory listing',
    'All client data preserved',
    'All session history preserved',
  ],
  'pro->free': [
    'Basic directory listing',
    'All client data preserved',
    'All session history preserved',
  ],
};
